import { Layers } from "appworks/graphics/layers/layers";
import { Services } from "appworks/services/services";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import Logger = require("js-logger");
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";
import { AlertComponent } from "slotworks/components/alert/alert-component";

export class PartnerConnectAlertComponent extends AlertComponent {
    public info(messageId: string): Contract<void> {
        if (this.fatal) {
            return Contract.never();
        }

        let message = this.getMessage(messageId);

        if (message === undefined || message === "" || !message) {
            message = Services.translations.get("General Error");
        }

        return new Contract((resolve) => {
            PartnerConnectManager.getUI().showPopup({
                message, primaryButtonText: Services.translations.get("OK"), primaryButtonAction: resolve
            });
        });
    }

    public error(messageId: string, fatal: boolean = false): Contract<void> {
        if (this.fatal) {
            return Contract.never();
        }

        if (fatal) {
            this.fatal = true;
            this.onFatal.dispatch();
        }

        let message = this.getMessage(messageId);

        if (message === undefined || message === "" || !message) {
            message = Services.translations.get("General Error");
        }

        if (!Layers.get("Alerts").hasAnyScene(["info", "error"])) {
            Logger.error(new Error().stack);
        }

        return new Parallel([
            () => Contract.wrapPromise(PartnerConnectManager.getEmitters().spinError()),
            () => new Contract((resolve) => {
                PartnerConnectManager.getUI().showPopup({
                    message, primaryButtonText: Services.translations.get("OK"), primaryButtonAction: () => {
                        if (fatal) {
                            location.reload();
                        } else {
                            resolve();
                        }
                    }
                });
            })
        ]);
    }
}
